module.exports = __webpack_public_path__ + "img/ic_64_achievement_volltreffer.920e5690.svg";